import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Table, Button, Pagination } from "react-bootstrap";
import { FaEdit, FaTrash, FaArrowLeft } from "react-icons/fa";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";

const getAuthToken = () => localStorage.getItem("authToken");

const PaymentList = () => {
    const [payments, setPayments] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 50;
    const navigate = useNavigate();

    useEffect(() => {
        fetchPayments(currentPage);
    }, [currentPage]);

    const fetchPayments = async (page) => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
        try {
            const response = await axios.get(`${appConstants.API_ROOT_URL}get-payments?page=${page}&limit=${limit}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setPayments(response.data.payments);
            setTotalPages(response.data.pagination.total_pages);
        } catch (error) {
            console.error("Error fetching payments:", error);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this payment?")) return;
    
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
    
        try {
            const response = await axios.post(`${appConstants.API_ROOT_URL}delete-payment`, 
                { payment_id: id }, // ✅ Send payment_id in request body
                {
                    headers: { 
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );
    
            alert(response.data.message || "Payment deleted successfully!");
            fetchPayments(currentPage);
        } catch (error) {
            console.error("Error deleting payment:", error);
            alert(error.response?.data?.message || "Error deleting payment. Please try again.");
        }
    };

    return (
        <Layout>
            <div className="p-3 bg-light">
                <Button variant="secondary" onClick={() => navigate(-1)}>
                    <FaArrowLeft /> Back
                </Button>
                <h5 className="mt-3">Payments List</h5>
                <Table striped bordered hover className="mt-3">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>No</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Amount</th>
                            <th>Description</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {payments.map(payment => (
                            <tr key={payment.id}>
                                <td>{payment.date}</td>
                                <td>{payment.payment_number}</td>
                                <td>{payment.from_account}</td>
                                <td>{payment.to_account}</td>
                                <td>{payment.amount}</td>
                                <td>{payment.description}</td>
                                <td>
                                    <Button variant="warning" size="sm" onClick={() => navigate(`/edit-payment/${payment.id}`)}>
                                        <FaEdit />
                                    </Button>
                                    <Button variant="danger" size="sm" className="ms-2" onClick={() => handleDelete(payment.id)}>
                                        <FaTrash />
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                <Pagination>
                    <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} />
                    {[...Array(totalPages)].map((_, index) => (
                        <Pagination.Item key={index} active={index + 1 === currentPage} onClick={() => setCurrentPage(index + 1)}>
                            {index + 1}
                        </Pagination.Item>
                    ))}
                    <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} />
                </Pagination>
            </div>
        </Layout>
    );
};

export default PaymentList;
